import Cookies from 'js-cookie'

const TokenKey = 'ahxmgk-manage-token-dian-'+ process.env.VUE_APP_Q

export function getToken() {
	if(process.env.VUE_APP_DEBUG) {
		return process.env.VUE_APP_TOKEN
	}
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token , { expires: 7 })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
